import { BaseValidator } from '../core/BaseValidator.js';
import { ValidationResult } from '../core/ValidationResult.js';

/**
 * South Korean Resident Registration Number validator following Single Responsibility Principle
 */
export class KrValidator extends BaseValidator {
  constructor() {
    super({
      name: 'Korean Resident Registration Number',
      pattern: /^\d{6}-?\d{7}$/,
      length: 13
    });
  }

  validateFormat(id) {
    const cleanId = id.replace(/-/g, '');
    
    // Check length
    const lengthValidation = this.validateLength(cleanId, this.config.length);
    if (!lengthValidation.isValid) {
      return lengthValidation;
    }

    // Check pattern
    return this.validateRegex(
      id,
      this.config.pattern,
      'RRN format must be YYMMDD-XXXXXXX or YYMMDDXXXXXXX'
    );
  }

  validateChecksum(id) {
    const cleanId = id.replace(/-/g, '');
    const weights = [2, 3, 4, 5, 6, 7, 8, 9, 2, 3, 4, 5];
    let sum = 0;

    for (let i = 0; i < 12; i++) {
      sum += parseInt(cleanId[i]) * weights[i];
    }

    const expectedChecksum = (11 - (sum % 11)) % 10;
    const actualChecksum = parseInt(cleanId[12]);

    if (expectedChecksum !== actualChecksum) {
      return ValidationResult.invalid(`Invalid RRN checksum. Expected: ${expectedChecksum}, Got: ${actualChecksum}`);
    }

    return ValidationResult.valid('Valid RRN');
  }
}